import { UserEntityPermission } from '@/app/shared/enums/UserEntityPermission';
import { GuestsVisibility } from '@/app/modules/seating/guestOperations/Picker/domain/enums/GuestsVisibility';

export const filterByUserEntityAndVisibility = (
    items,
    userEntity,
    guestsVisibility,
    { participantSelector } = { participantSelector: (item) => item }
) => {
    if (!userEntity) {
        if (guestsVisibility === GuestsVisibility.LIMITED_BY_ENTITY) {
            return items.filter((item) => {
                const participant = participantSelector(item);
                return (
                    !participant.participant_group ||
                    participant.participant_group?.entity_ids.length === 0
                );
            });
        }

        return items;
    }

    if (
        userEntity.permission === UserEntityPermission.LIMITED_ACCESS ||
        (userEntity.permission === UserEntityPermission.FULL_ACCESS &&
            guestsVisibility === GuestsVisibility.LIMITED_BY_ENTITY)
    ) {
        return items.filter((item) =>
            participantSelector(item).participant_group?.entity_ids.some(
                (entityId) => entityId === userEntity.id
            )
        );
    }

    return items;
};
